<template>
    <div class="bmd-layout-container bmd-drawer-f-l bmd-drawer-overlay">
      <header class="bmd-layout-header">
        <div class="navbar navbar-light bg-faded">
          <button class="navbar-toggler btn" type="button" data-toggle="drawer" data-target="#">
<!--          <button class="navbar-toggler btn" type="button" data-toggle="drawer" data-target="#dw">-->
            <span class="sr-only">Toggle drawer</span>
<!--            <i class="material-icons">menu</i>-->
          </button>
          <router-link class="router-link no-underline" to="/">
<!--            <img class="title-icon" src="../static/favicon.png"/>-->
            <span class="title-text">
              Mask Nearby
            </span>
          </router-link>
          <ul class="nav navbar-nav">
            <li class="nav-item">
            </li>
          </ul>
        </div>
      </header>

      <main class="bmd-layout-content">
        <router-view/>
      </main>
    </div>

</template>

<script>
import moment from "moment";
import Constants from "./constants";

export default {
  data () {
    return {
      localStorage: null,
      favoriteList: []
    }
  },
  name: 'App',
  watch:{
    $route () {
      // this.isStorageAvailable();
    },
  },
  mounted () {
    // this.isStorageAvailable();
  },
  methods: {
    isStorageAvailable: function() {
      let storage;
      try {
        storage = window['localStorage'];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        this.localStorage = storage;
        let rest = this.localStorage.getItem('rest');
        if (rest != null) {
          this.favoriteList = rest.split(',');
        }
        return true;
      }
      catch(e) {
        return e instanceof DOMException && (
                // Firefox를 제외한 모든 브라우저
                e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // 코드가 존재하지 않을 수도 있기 떄문에 이름 필드도 확인합니다.
                // Firefox를 제외한 모든 브라우저
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                // 이미 저장된 것이있는 경우에만 QuotaExceededError를 확인하십시오.
                (storage && storage.length !== 0);
      }
    }
  }
}

</script>

<style scoped>
  .router-link {
    font-weight: bold;
    color: black;
  }

  .no-underline {
    text-decoration: none;
  }

  .title-icon {
    width: 20px;
    margin-right: 5px;
  }

  .title-text {
    vertical-align: middle;
  }

  .title-center {
    margin-right: 50px;
  }

  .card {
    margin: 0 20px 20px;
  }

  .favorite-card {
    font-weight: bold;
  }

  .router-link-text {
    display: flex;
    align-items: center;
  }

  .star-button {
    align-content: center;
    padding: 0;
    margin: 0 0 0 5px;
  }

  .star-icon {
    margin: 3px 0 0;
  }

  .title-badge {
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue